import _ from 'lodash';

export function useArrays() {
  function listsAreEqual<T>(list1:T[], list2:T[]) {
    function customizer(value1: T, value2: T) {
      if (_.isDate(value1) || _.isDate(value2)) {
        return _.isEqual(_.isDate(value1) ? value1.toISOString() : value1, _.isDate(value2) ? value2.toISOString() : value2);
      } else {
        // return undefined to let lodash handle the comparison
        return undefined;
      }
    }

    return _.isEqualWith(list1.sort(), list2.sort(), customizer);
  }

  return {
    listsAreEqual
  };
}

type Primitive = string | number | symbol | bigint | boolean;

export function hasIntersection(a: readonly Primitive[] | Primitive[], b: readonly Primitive[] | Primitive[]): boolean {
  return a.some(value => b.includes(value));
}

export function isEmpty<T>(arr: T[]): boolean {
  return arr.length === 0;
}
